// File created by Reginald Sahil Chand on 26-03-2024.

import React, {type ReactElement} from 'react';

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @property {string} logoText - Text to show as the application and or company logo. (This property is not optional).
 *
 * @version 0.1.0
 */
type LogoProps = {
	logoText: string;
};

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @description Render the logo title of a company or an application.
 *
 * @type {LogoProps}
 * @version 0.1.0
 *
 * @return {JSX Element} Logo component.
 */
export const Logo: React.FC<LogoProps> = React.memo(({logoText}: LogoProps): ReactElement => {
	const initialLogoText: string = (logoText && logoText) ?? 'Logo';

	return (
		<a
			href="/"
			title={logoText}
			aria-label={logoText}
			tabIndex={0}
			className={
				'w-40 h-full flex items-center justify-center rounded-lg transition-colors duration-300 ease-in-out text-text bg-primary hover:bg-secondary md:cursor-pointer'
			}
		>
			<h1 className="font-bold">{initialLogoText}</h1>
		</a>
	);
});

Logo.displayName = 'Logo';
